import BaseClass from "../BaseClass.js";

export default class ModalHandler extends BaseClass {
    constructor(element = null, contentUrl = null, contentData = null) {
        super(element);

        this.$modalsContainer = null;
        this.contentUrl = contentUrl;
        this.contentData = contentData;
        this.modalID = null;
        this.$modalBody = null;
        this.modalElement = null;
        this.modalBootStrapObject = null;
        this.disabled = false;
        this.showModalEventListener = null;
        this.shownModalEventListener = null;
        this.hideModalEventListener = null;
        this.hideAllModalEventListener = null;
        this.hiddenModalEventListener = null;
        this.reloadEventListener = null;
        this.clickListener = null;
        this.autoOpen = false;

        this.init();
    }

    init() {
        const mySelf = this;
        let $modalsContainer = $('#modals-container');
        if ($modalsContainer) {
            this.$modalsContainer = $modalsContainer;
        }
        if (this.$element != null) {
            this.clickListener = function (event) {
                if (mySelf.disabled) {
                    return;
                }
                mySelf.disabled = true;
                event.preventDefault();
                event.stopPropagation();
                mySelf.loadModal();
            };

            this.$element.on('click', this.clickListener);
            this.contentUrl = this.$element.data('url');

            let $modalID = this.$element.data('modal-id');
            if ($modalID != undefined) {
                this.modalID = 'modal_' + $modalID + '_' + this.generateRandomString(10);
            } else {
                this.modalID = 'modal_' + this.generateRandomString(10);
            }

        } else {
            this.modalID = 'modal_' + this.generateRandomString(10);
        }
        this.createListener();

        // auto-open
        if (this.$element != null) {
            let autoOpen = this.$element.data('auto-open');

            if (autoOpen != undefined && autoOpen == 1) {
                this.autoOpen = true;
            }

            if (this.autoOpen) {
                this.loadModal();
            }
        }
    }

    createListener() {
        let mySelf = this;

        this.showModalEventListener = function () {
            $(document).trigger("modal:show");
        };

        this.shownModalEventListener = function () {
            $(document).trigger("modal:shown");
            $(document).trigger("content:loaded");
        };

        this.hideModalEventListener = function (event, data) {
            if (mySelf.modalBootStrapObject != null) {
                if (data && data.childelementID) {
                    let modalChild = mySelf.$modalBody.find('#' + data.childelementID);
                    if (modalChild.length == 1) {
                        mySelf.modalBootStrapObject.hide();
                    }
                }
            }
        };

        this.hideAllModalEventListener = function (event, data) {
            if (mySelf.modalBootStrapObject != null) {
                mySelf.modalBootStrapObject.hide();
            }
        };

        this.hiddenModalEventListener = function () {
            $(document).trigger("modal:hidden");
            mySelf.removeOldModal();
        };

        this.reloadEventListener = function (event, data) {
            if (data != undefined) {

                if (data.childelementID != undefined) {
                    let modalChild = mySelf.$modalBody.find('#' + data.childelementID);
                    if (modalChild.length == 1) {
                        mySelf.loadModal(true);
                    }
                }
            }
        };
    }

    loadModal(reload = false) {
        let mySelf = this;
        let postData = "modalID=" + this.modalID + "&reload=";

        if (reload) {
            postData += 1;
        } else {
            //   $(document).trigger("modals:hide"); // Mehrere Modals anzeigen
            postData += 0;
        }

        let additionalPostData = null;

        if (this.$element != null) {
            additionalPostData = this.$element.attr('data-modaldata');
        } else if (mySelf.contentData != null) {
            additionalPostData = mySelf.contentData;
        }

        if (additionalPostData != null && additionalPostData.length > 0) {
            postData = postData + "&" + additionalPostData;
        }

        $(document).trigger('show:loading');

        let jqxhr = $.post(this.contentUrl, postData, function () {
        }, 'html')
            .done(function (modalHTML) {
                mySelf.insertModal(modalHTML, reload);
            })
            .fail(function (data) {
                mySelf.disabled = false;
            })
            .always(function () {
                $(document).trigger('hide:loading');
            });
    }

    insertModal(modalHTML, reload) {
        let mySelf = this;
        if (reload) {
            if (this.$modalBody != null) {
                this.$modalBody.html(modalHTML);
                $(document).trigger("content:loaded");
            }
        } else {
            this.removeOldModal();
            this.$modalsContainer.append(modalHTML);
            let $newModalElement = $('#' + this.modalID);
            if ($newModalElement.length == 1) {
                this.$modalBody = $newModalElement.find('[data-type="modal_body"]');
                this.modalElement = document.getElementById(this.modalID);
                this.modalBootStrapObject = new bootstrap.Modal(this.modalElement);

                this.modalElement.addEventListener('show.bs.modal', this.showModalEventListener);
                this.modalElement.addEventListener('shown.bs.modal', this.shownModalEventListener);
                this.modalElement.addEventListener('hide.bs.modal', this.hiddenModalEventListener); // workaround, hidden.bs.modal nicht zuverlässlig
                this.modalElement.addEventListener('hidden.bs.modal', this.hiddenModalEventListener);
                $(document).on("modals:hide", this.hideAllModalEventListener);
                $(document).on("modal:hide", this.hideModalEventListener);
                $(document).on("modal:reload", this.reloadEventListener);
                this.modalBootStrapObject.show();
            }
        }
    }

    destroyListener() {
        if (this.modalElement != null) {
            this.modalElement.removeEventListener('show.bs.modal', this.showModalEventListener);
            this.modalElement.removeEventListener('shown.bs.modal', this.shownModalEventListener);
            // this.modalElement.removeEventListener('hide.bs.modal', this.hideModalEventListener);
            this.modalElement.removeEventListener('hidden.bs.modal', this.hiddenModalEventListener);
            $(document).off("modal:reload", this.reloadEventListener);
            $(document).off("modals:hide", this.hideAllModalEventListener);
            $(document).off("modal:hide", this.hideModalEventListener);
        }
        if (this.clickListener != null) {
            this.$element.on('click', this.clickListener);
        }
    }

    removeOldModal() {
        let $oldModalElement = $('#' + this.modalID);
        if ($oldModalElement.length == 1) {
            this.destroyListener();
            delete this.modalBootStrapObject;
            this.modalBootStrapObject = null;
            $oldModalElement.remove();
            this.disabled = false;
        }
    }
}